import { defineComponent as _defineComponent } from 'vue'
import AiIcon from '@/components/svg/ai-icon-small.svg?inline';
import useI18n from '@/mixins/useI18n';
import useProfilePdfUploadPopup from '@/views/profile/composables/useProfilePdfUploadPopup';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileAssistantButton',
  setup(__props) {

const { t } = useI18n();
const { open } = useProfilePdfUploadPopup();

return { __sfc: true,t, open, AiIcon }
}

})